import { styled as l } from "@mui/material";
import C from "../../share/apeiron/ApeironBlueButton.js";
import { useGeetest4Context as w } from "../../../contexts/account/Geetest4Context.js";
import { useMessageContext as _ } from "../../../contexts/share/MessageContext.js";
import { useCountDownTimer as g } from "../../../hooks/generic/useCountdownTimer.js";
import h from "../../../hooks/graphql/useSendOtpCode.js";
import { noForwardProps as x } from "../../../util/styled/index.js";
import { useCallback as y } from "react";
import { useTranslation as T } from "react-i18next";
import { jsx as b } from "react/jsx-runtime";
const k = l(C, x)`
  width: 120px;
  height: 40px;

  &.Mui-disabled {
    color: ${(o) => o.__inCooldown ? "#ffffff" : "#777979"};
  }
`, A = (o) => {
  const {
    t: e
  } = T(), {
    email: s,
    disabled: a,
    otpType: d,
    cooldown: n = 60
  } = o, [t, r] = g(), {
    doGeetest: i
  } = w(), {
    setSnackInfo: c
  } = _(), {
    mutate: m
  } = h(d), p = y(async () => {
    i(async (u) => {
      try {
        await m({
          email: s,
          geeTest: u
        }) && (c({
          message: e("account_setting.otp_sent"),
          serverity: "success"
        }), r(n));
      } catch {
      }
    });
  }, [n, s, i, m, c, r, e]);
  return /* @__PURE__ */ b(k, {
    disabled: a || t > 0,
    __inCooldown: t > 0,
    onClick: p,
    children: t > 0 ? `${t}s` : e("account_setting.send_otp")
  });
};
export {
  A as default
};
//# sourceMappingURL=SendEmailOTPButton.js.map
